import { render, staticRenderFns } from "./DeliveryCutoffReport.vue?vue&type=template&id=2791fb43&scoped=true"
import script from "./DeliveryCutoffReport.vue?vue&type=script&lang=js"
export * from "./DeliveryCutoffReport.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCutoffReport.vue?vue&type=style&index=0&id=2791fb43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2791fb43",
  null
  
)

export default component.exports